export const CF_VIDEO_TYPE_DICTIONARY = {
  local: "local",
  youtube: "youtube",
};
